export { default } from "./Dot-component";
